import React from 'react';
import { RUOLI } from "../../applicationConf";
import CorsoDettaglioLink from "./CorsoDettaglioLink";
import {useSelector} from "react-redux";
import { isPwa } from '../../fanctionUtility';

const CorsoDettaglioButton = ({ dati }) => {
    const config = useSelector(state => state.config.data);
    const ruoloScelto = useSelector(state => state.auth.ruoloScelto);

    const link = RUOLI[ruoloScelto.toUpperCase()].BUTTON;
    const links = link.filter(obj => obj.TIPO.includes(dati.tipoCorso))
        .map(tipoCorso => tipoCorso.CAMPI.map(objLink => {
            if (new Date(dati.dataInizio).getTime() > new Date('2024-07-29') && objLink.LINK === '/profilazioneFSE') {
                return null
            }
            if (isPwa()) {
                return null
            }

            if (objLink.LINK === '/pianificazione/inserisci' && config != null && !config?.pianificazioniEnabled) {
                return null
            }
        return <CorsoDettaglioLink dati={dati}
        objLink={objLink}
        key={Math.random().toString(33).replace('0.', '')}/>}));
    const esportaButton = {
        DISPLAY_VALUE: "Esporta",
        LINK: "/esporta"
    }

    return (
        <div className="d-flex flex-wrap flex-row">
            {links}

            {!isPwa() && (
                <CorsoDettaglioLink dati={dati}
                                objLink={esportaButton}
                                key={Math.random().toString(33).replace('0.', '')}/>
            )}
        </div>
    )
};


export default CorsoDettaglioButton;
